import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PasskeysSettings from '../components/PasskeysSettings';
import { getPasskeyCredentials, getPasskeyRedirectUrl, getShowPasskeyNudge } from '../selectors/PasskeysSelector';
import { createPasskey, deletePasskey, fetchPasskeys, togglePasskeyDeleteModal, togglePasskeyRenameModal, setupPasskeyFromNudge, renamePasskey } from '../actions/PasskeysActions';
import { fetchSsoSettings } from '../actions/SsoActions';
import { getEmailFromAuth, getIsUserImpersonated, getPasskeysIsUngated, getUserIdFromAuth } from '../selectors/AuthSelector';
import { getDeletePasskeyError, getRenamePasskeyError } from '../selectors/ErrorSelector';
import { getDeletePasskeyModalOpen, getRenamePasskeyModalOpen } from '../selectors/InteractionSelector';
import { getCanShowPasskeys } from '../selectors/SsoSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const PasskeysSettingsContainer = props => {
  if (props.passkeysIsUngated && props.canShowPasskeys) {
    return /*#__PURE__*/_jsx(PasskeysSettings, Object.assign({}, props));
  }
  return null;
};
const mapStateToProps = (state, ownProps) => {
  return {
    passkeyCredentials: getPasskeyCredentials(state),
    passkeysIsUngated: getPasskeysIsUngated(state),
    email: getEmailFromAuth(state),
    userId: getUserIdFromAuth(state),
    deletePasskeyError: getDeletePasskeyError(state),
    renamePasskeyError: getRenamePasskeyError(state),
    deletePasskeyModalOpen: getDeletePasskeyModalOpen(state),
    renamePasskeyModalOpen: getRenamePasskeyModalOpen(state),
    showPasskeyNudge: getShowPasskeyNudge(state),
    passkeyRedirectUrl: getPasskeyRedirectUrl(state),
    canShowPasskeys: getCanShowPasskeys(state),
    isHubless: ownProps.isHubless,
    isUserImpersonated: getIsUserImpersonated(state)
  };
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
PasskeysSettingsContainer.defaultProps = {
  isHubless: false
};
export default withRouter(connect(mapStateToProps, {
  createPasskey,
  deletePasskey,
  renamePasskey,
  fetchPasskeys,
  togglePasskeyDeleteModal,
  togglePasskeyRenameModal,
  setupPasskeyFromNudge,
  fetchSsoSettings
})(PasskeysSettingsContainer));